import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AuthLayout } from "../layouts/AuthLayout";
import { AuthFormLayout } from "../layouts/AuthFormLayout";

/**
 * Email verification is not available - backend has no OTP/verify endpoint.
 * Shown when users navigate here directly (e.g. from old bookmark).
 */
const VerifyEmail = () => {
  return (
    <AuthLayout showBranding={false}>
      <AuthFormLayout
        title="Email verification"
        subtitle="If you have an account, you can sign in."
      >
        <p className="text-muted-foreground text-sm mb-6">
          Email verification is not required for this application. If you have an
          account, go to the login page to sign in.
        </p>
        <Link
          to="/login"
          className="flex items-center justify-center gap-2 text-sm text-muted-foreground hover:text-foreground mt-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to login
        </Link>
      </AuthFormLayout>
    </AuthLayout>
  );
};

export default VerifyEmail;
